import React from 'react'
import { GameBoardContainer } from '../../../components/gameBoard/GameBoardStyles'
import Table from './Table'
import Player from './Player'
import Dealer from './Dealer'

function Cards({ cards, winCombination }: any): any {
  return (
    <>
      <GameBoardContainer>
        <Dealer
          cardList={cards.slice(7, 9)}
          winCombination={winCombination.slice(7, 9)}
        />
        <Table
          cardList={cards.slice(2, 7)}
          winCombination={winCombination.slice(2, 7)}
        />
        <Player
          cardList={cards.slice(0, 2)}
          winCombination={winCombination.slice(0, 2)}
        />
      </GameBoardContainer>
    </>
  )
}

export default Cards
